import { createAction } from 'redux-actions'

export const addDownloadTaskId = createAction('FILE_DOWNLOADS/ADD_TASK_ID')
export const removeDownloadTaskId = createAction(
  'FILE_DOWNLOADS/REMOVE_TASK_ID',
)
